/**
 * exportCSV — zero-dependency CSV export utility
 * Usage: exportCSV('filename', headers, rows)
 */

export function exportCSV(filename: string, headers: string[], rows: (string | number | boolean | null | undefined)[][]): void {
  const escape = (v: string | number | boolean | null | undefined): string => {
    if (v === null || v === undefined) return '';
    const s = String(v);
    // Wrap in quotes if contains comma, quote, or newline
    if (s.includes(',') || s.includes('"') || s.includes('\n')) {
      return '"' + s.replace(/"/g, '""') + '"';
    }
    return s;
  };

  const lines: string[] = [
    headers.map(escape).join(','),
    ...rows.map(row => row.map(escape).join(',')),
  ];

  const csv = lines.join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Formats a Date or epoch ms as YYYY-MM-DD for filenames */
export function csvDateStamp(d?: Date | number): string {
  const dt = d ? new Date(d) : new Date();
  return dt.toISOString().slice(0, 10);
}
